import Vue from 'vue'
import vuex from 'vuex'
// 引入子模块
import app from './modules/app'
import tab from './modules/tab'
import iframe from './modules/iframe'
import user from './modules/user'
import menu from './modules/menu'
import hospital from "./modules/hospital";
import department from "./modules/department";
import bindInfo from "./modules/bindInfo";
import doctor from "./modules/doctor";
import dictionary from "./modules/dictionary";
import dept from "./modules/dept";

Vue.use(vuex);

const store = new vuex.Store({
  modules: {
    app: app,
    tab: tab,
    iframe: iframe,
    user: user,
    menu: menu,
    hospital: hospital,
    department: department,
    bindInfo: bindInfo,
    dictionary: dictionary,
    doctor: doctor,
    dept: dept
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js